import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import styled from 'styled-components';
import idGenerator from 'react-id-generator';
import { media } from 'styled-bootstrap-grid';

import { ChevronRightIcon, ChevronLeftIcon } from '@root/styles/icons';

import Portal from '@common/components/Portal';

const ArrowLeft = ({ id, infinite, currentSlide, 'data-role': dataRole, style, onClick }) => (
  <Portal selector={`#${id} .arrow-back`}>
    <button
      type="button"
      data-role={dataRole}
      style={style}
      onClick={onClick}
      disabled={!infinite && currentSlide === 0 ? 'disabled' : null}
      className="slick-arrows arrow-left"
    >
      <ChevronLeftIcon width="18" height="18" viewBox="4 1 18 18" />
    </button>
  </Portal>
);

const ArrowRight = ({
  id,
  infinite,
  currentSlide,
  slideCount,
  'data-role': dataRole,
  style,
  onClick,
}) => (
  <Portal selector={`#${id} .arrow-forward`}>
    <button
      type="button"
      data-role={dataRole}
      style={style}
      onClick={onClick}
      disabled={!infinite && currentSlide >= slideCount - 1}
      className="slick-arrows arrow-right"
    >
      <ChevronRightIcon width="18" height="18" viewBox="2 1 18 18" />
    </button>
  </Portal>
);

const SliderWrapper = styled.div`
  .arrows {
    position: absolute;
    top: 0;
    right: 20px;
    display: flex;
    margin: 0 -5px;
    z-index: 1;
  }

  .slick-arrows {
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: ${({ theme }) => `1px solid ${theme.defaultColors.grey}`};
    color: ${({ theme }) => theme.defaultColors.fontPrimary};
    background: #fff;
    margin: 0 5px;
    transition: background 0.5s ease;
    cursor: pointer;
    outline: none;
    &:hover {
      background: ${({ theme }) => theme.defaultColors.lighterGrey};
    }
    &:disabled {
      background: #fff;
      border-color: ${({ theme }) => theme.defaultColors.lightGrey};
      color: ${({ theme }) => theme.defaultColors.lightGrey};
      cursor: initial;
    }
  }

  ${media.md`
    padding-top: 40px;
  `}
`;

class WrappedSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,
    };
    this.id = idGenerator();
  }

  render() {
    const { isDragging } = this.state;
    const { children, infinite } = this.props;
    return (
      <SliderWrapper>
        <div id={this.id} className="arrows">
          <div className="arrow-back" />
          <div className="arrow-forward" />
        </div>
        <Slider
          {...this.props}
          infinite={infinite}
          nextArrow={<ArrowRight id={this.id} infinite={infinite} />}
          prevArrow={<ArrowLeft id={this.id} infinite={infinite} />}
          beforeChange={() => this.setState({ isDragging: true })}
          afterChange={() => this.setState({ isDragging: false })}
        >
          {Children.map(children, (child) =>
            cloneElement(child, {
              ...child.props,
              isDragging,
            })
          )}
        </Slider>
      </SliderWrapper>
    );
  }
}

WrappedSlider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  infinite: PropTypes.bool,
};

WrappedSlider.defaultProps = {
  infinite: false,
};

export default WrappedSlider;
